<template>
    <div class="statistics-data" :style="{background:bgColor}">
      <img class="icon" :src="icon">
      <div class="title">{{title}}</div>
      <div class="value" :style="{color:color}">{{value||0}}</div>
    </div>
</template>

<script>
    export default {
        props:["icon","title","bgColor","color","value"]
    }
</script>

<style scoped lang="less">

  .statistics-data{
    padding: 10px;
    border-radius: 4px;
    margin: 5px;
    flex: 1;

    .icon{
      width: 30px;
      height: 30px;
      float: left;
      margin-right: 10px;
    }

    .title{
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
    }

    .value{
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      margin-left: 40px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/home/_components/StatisticsData.vue